import React from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Box, Container } from '@mui/material';

const BreadcrumbsNav = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const generateBreadcrumbName = (segment) => {
    const map = {
      'book-overview': 'Book Overview',
      'examwise-books': 'Examwise Books',
      'result': 'Result',
      'contact': 'Contact Us',
      'blog': 'Blog',
      'faq': 'FAQ',
      'about': 'About Us',
      'login': 'Login',
      'register': 'Register',
      'cart': 'Shipping cCart',
      'terms&conditions': 'Terms & Conditions',
      'checkout': 'Checkout',
    };
    return map[segment] || decodeURIComponent(segment.charAt(0).toUpperCase() + segment.slice(1));
  };

  if (location.pathname === '/') return null;

  return (
    <Box sx={{ backgroundColor: '#EEEEEE' }}>

      <Container maxWidth="xl">

        <div style={{ padding: '10px' }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              component={RouterLink}
              color="inherit"
              to="/"
              sx={{
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' }
              }}
            >
              Home
            </Link>
            {pathnames.map((value, index) => {
              const to = `/${pathnames.slice(0, index + 1).join('/')}`;
              const isLast = index === pathnames.length - 1;
              return isLast ? (
                <Typography color="text.primary" key={to}>
                  {generateBreadcrumbName(value)}
                </Typography>
              ) : (
                <Link
                  component={RouterLink}
                  color="inherit"
                  to={to}
                  key={to}
                  sx={{
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' }
                  }}
                >
                  {generateBreadcrumbName(value)}
                </Link>
              );
            })}
          </Breadcrumbs>
        </div>
      </Container>
    </Box>
  );
};

export default BreadcrumbsNav;
